import { useSelfcare } from "modules/selfcare/hooks/useSelfcare";

export function useUserName() {
  const { data } = useSelfcare(false);

  return data?.name;
}
